import { render } from "./AlertsFrameWindowsPage.vue?vue&type=template&id=5072a1a2"
import script from "./AlertsFrameWindowsPage.vue?vue&type=script&lang=js"
export * from "./AlertsFrameWindowsPage.vue?vue&type=script&lang=js"

import "./AlertsFrameWindowsPage.vue?vue&type=style&index=0&id=5072a1a2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__